import { render, staticRenderFns } from "./AlUser.vue?vue&type=template&id=6ca598bc&scoped=true&"
import script from "./AlUser.vue?vue&type=script&lang=js&"
export * from "./AlUser.vue?vue&type=script&lang=js&"
import style0 from "./AlUser.vue?vue&type=style&index=0&id=6ca598bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca598bc",
  null
  
)

export default component.exports